<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
                   <template slot-scope="scope" slot="outboundAmount">
                    <div class="money"><span>{{tool.money_format_allowvoid(scope.row.outboundAmount)  }}</span></div>
                   </template>
                   <template slot="searchMenu">

                        <div style="display: inline-block; margin:0 20px 0 20px">汇总金额</div>
                        <moneyInput v-model="money"  disabled  style= "display: inline-block; width: 150px"  />
                    </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text"
                           size="small"
                           v-if="permissionList.viewBtn"
                           icon="el-icon-view"
                           @click="openViewDialog(scope.row,permissionList.auditBtn)">查看
                </el-button>
            </template>
            <template slot="projectIdSearch">
                 <el-select v-model="searchForm.projectId" placeholder="请选择">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="warehouseIdSearch">
                <el-select v-model="searchForm.warehouseId" placeholder="仓库名称">
                    <el-option
                        v-for="item in warehouseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="outboundTime2Search" slot-scope="scope">
                <el-date-picker
                    v-model="valuetime"
                    type="daterange"
                    :start-default-value="defaultTime"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
                </el-date-picker>
            </template>
            <template slot="moneySearch" slot-scope="scope">
                <el-input v-model="money" disabled></el-input>
            </template>
            <template slot="userNameSearch" slot-scope="scope">
                 <el-select
                    v-model="searchForm.requisitionUser"
                    filterable
                    placeholder="申请人"
                    >
                    <el-option
                    v-for="item in userlist"
                    :key="item.id"
                    :label="item.realNameAndPhone"
                    :value="item.id">
                    </el-option>
                </el-select>
            </template>
            <template slot="linkNo2Search">
                <el-input  v-model="searchForm.linkNo2" maxlength=21
                placeholder="领用单号"
                                    :showWordLimit='true'></el-input>
            </template>
        </avue-crud>
        <recipientsFrom ref="recipientsFrom" @onLoad="onLoad"></recipientsFrom>
    </basic-container>
</template>

<script>
import {getSummary,getList,getUserlist} from "@/api/crmedical/warehouse/outbound/record.js"
    import {mapGetters} from "vuex";
    import recipientsFrom from "./outbound-record-form.vue";
    import {
        getProjectList,
        getWarehouseList,
        getDict,
    } from "@/api/crmedical/warehouse/index.js";
    import {userList } from '@/api/crmedical/contract/add/index.js'
    export default {
        components:{
            recipientsFrom
        },
        data() {
            return {
                routerQuery:{},
                form: {},
                valuetime:'',
                query: {},
                money:0,
                loading: false,
                defaultTime:'',
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                onloadFlag:false,//为了避免第一次请求必须在projecid赋值后进行
                selectionList: [],
                searchForm:{
                    projectId:'',
                    warehouseId:'',
                    people:''
                },
                projectList:[],//项目名称
                warehouseList:[],//仓库名称
                statusList:[],//状态
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    addBtn:false,
                    searchShow: true,
                    searchMenuSpan: 10,
                    menuPosition:'center',
                    border: true,
                    index: true,
                    searchMenuSpan:8,
                    emptyBtn:true,
                    viewBtn: false,
                    selection: false,
                    dialogClickModal: false,
                    stripe:true,
                    column: [

                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    dicUrl: '/api/v4ward/project/getProjectList',
                                    search: true,
                                    type:'select',
                                    searchslot:true,
                                    dataType: 'string',
                                    dicData:[],
                                    props:{
                                        label:'name',
                                        value:'id'
                                    },
                                    value:'',
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "出库单号",
                                    prop: "outboundNo",

                                },
                                {
                                    label: "领用单号",
                                    prop: "linkNo",

                                },
                                {
                                    label: "仓库名称",
                                    prop: "warehouseName",

                                },

                                {
                                    label: "仓库名称",
                                    prop: "warehouseId",
                                    search: true,
                                    hide:true,
                                    searchslot:true,
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请选择仓库",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "领用科室",
                                    prop: "requisitionDeptName",
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请输入货品id",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "出库人",
                                    prop: "outboundNamePhone",
                                },
                                {
                                    label: "出库时间",
                                    prop: "outboundTime",
                                },
                                {
                                    label: "出库总金额",
                                    prop: "outboundAmount",
                                    slot:true
                                },
                                 {
                                    label: "确认人",
                                    prop: "confirmUserPhone",
                                },
                                {
                                    label: "确认时间",
                                    prop: "confirmTime",
                                },

                                 {
                                    label: "申请人",
                                    prop: "requisitionUser",
                                    // searchslot:true,
                                    type:'tree',
                                    hide:true,
                                    props:{
                                        label: 'realNameAndPhone',
                                        value: 'id'
                                     },
                                    dicData:[],
                                    search: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入领用数",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "出库时间",
                                    prop: "outboundTime2",
                                    search:true,
                                    slot:true,
                                    hide:true,
                                    type: 'datetimerange',
                                    searchslot:true,
                                    rangeSeparator:"至",

                                },
                                //  {
                                //     label: "确认状态",
                                //     prop: "outboundStatus",
                                // },
                                {
                                    label: "确认状态",
                                    prop: "outboundStatus",
                                    search: true,
                                    searchSpan:4,
                                    type:'select',
                                    dataType:'number',
                                    dicUrl:'/api/blade-system/dict/dictionary?code=warehouse_outbound_status',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择状态",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "领用单号",
                                    prop: "linkNo2",
                                    search: true,
                                    hide:true,
                                    searchslot:true,
                                    maxlength: 21,
                                    showWordLimit: true,

                                },
                                {
                                    label: "出库单号",
                                    prop: "outboundNo2",
                                    search: true,
                                    hide:true,
                                    maxlength: 21,
                                    showWordLimit: true,

                                },
                                              ]
                },
                data: [],
                userlist: [],
        value: [],
        list: [],
        loading: false,

      }

        },
          mounted() {
            this.list = this.states.map(item => {
                return { value: `value:${item}`, label: `label:${item}` };
            });
        },
        created() {

                this.routerQuery = this.$route.query;
                this.fetchData();
                setTimeout(()=>{
                    window.onresize = ()=>{
                        this.$refs.crud.$refs.table.doLayout();
                    }
                })
                // this.$nextTick(() => {
        //     setTimeout(()=>{
        //       this.$refs.crud.$children[1].$children[2].$el.addEventListener("click", ()=>{

        //             if(this.option.height == this.bodyHeight - 390){
        //               this.option.height = this.bodyHeight - 280
        //             }else{
        //               this.option.height = this.bodyHeight - 390;
        //             }
        //             this.$refs.crud.getTableHeight();
        //         });
        //       })

        // });
            this.option.height = this.bodyHeight - 390;
        },
        computed: {
            ...mapGetters(["permission",'userInfo']),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehouserequisitionconsumable_add, false),
                    viewBtn: this.vaildData(this.permission.warehouserequisitionconsumable_view, true),
                    delBtn: this.vaildData(this.permission.warehouserequisitionconsumable_delete, false),
                    editBtn: this.vaildData(this.permission.warehouserequisitionconsumable_edit, false),
                    auditBtn: this.vaildData(this.permission.warehouserequisitionconsumable_audit, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        watch:{
            'searchForm.projectId'(val){
                console.log(1212)
                this.getWarehouseList();
                this.getUserListByProjectId(val);
            }
        },
        methods: {
             // 获取仓库列表
            getWarehouseList(){
                    this.searchForm.warehouseId = '';
                    getWarehouseList({projectId:this.searchForm.projectId}).then(res=>{
                        this.warehouseList = res.data;
                        let warehouseIdColumn  = this.findObject(this.option.column, "warehouseId");
                        warehouseIdColumn.dicData = this.warehouseList
                        this.searchForm.warehouseId = this.warehouseList[0] ? this.warehouseList[0].id : '';
                    })
            },
            // 根据项目id 获取申请人
            getUserListByProjectId(projectId) {
                userList({projectId:projectId}).then(res=>{
                    this.userlist = res.data;
                    let requisitionUsercolumn  = this.findObject(this.option.column, "requisitionUser");
                    requisitionUsercolumn.dicData = this.userlist;
                });
            },
            async fetchData() {
                this.pageLoading = true;

                let userId= this.userInfo.user_id

                // getUserlist().then(res=>{
                //     this.userlist = res.data;
                //     let requisitionUsercolumn  = this.findObject(this.option.column, "requisitionUser");
                //     requisitionUsercolumn.dicData = this.userlist;
                // });

                try {
                    //projectList
                    const resProjectList = await getProjectList();
                    this.projectList = resProjectList.data;


                    this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';

                    //warehouseList
                    const resWarehouseList = await getWarehouseList({
                        projectId: this.searchForm.projectId,
                    });
                    this.warehouseList = resWarehouseList.data;
                    this.searchForm.warehouseId = this.warehouseList[0]? this.warehouseList[0].id: "";
                    this.onloadFlag = true;
                    this.onLoad();
                    //type && status
                    const dicts = await Promise.all([
                        getDict({ code: "warehouse_inbound_type" }),
                        getDict({ code: "inbound_status" }),
                    ]);
                    this.warehouseInboundTypeList = dicts[0].data;
                    this.searchForm.type = this.warehouseInboundTypeList[0].dictKey;
                    this.inboundStatusList = dicts[1].data;
                    this.searchForm.inboundStatus = this.inboundStatusList[0].dictKey;
                    //load list
                    // this.loadList();
                } catch (err) {
                    console.log("err==>", err);
                }
                this.pageLoading = false;
                },

            // 打开查看弹窗
            openViewDialog(row,auditBtn){
                let dicData = {

                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                console.log(this.$refs.recipientsFrom)
                this.$refs.recipientsFrom.openDialog({type:'view',dicData:dicData,data:row,auditBtn:auditBtn,});
            },
            // 搜索重置方法
            searchReset() {
                this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';
                this.searchForm.linkNo2 = '';
                this.query.requisitionNo2 = '';
                this.query.requisitionUser = '';
                this.valuetime = ''
                this.query = {};
                this.$refs.crud.toggleSelection();
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                if(!this.onloadFlag){
                    return;
                }
                page = page || this.page;
                if(this.routerQuery.projectId){
                    this.searchForm.projectId = this.routerQuery.projectId;
                    this.searchForm.warehouseId = this.routerQuery.warehouseId;
                    this.searchForm.linkNo2 = this.routerQuery.requisitionNo;
                    this.$route.query.projectId = '';
                    this.$route.query.warehouseId = '';
                    this.$route.query.requisitionNo = '';

                }
                this.query.projectId = this.searchForm.projectId || '';//项目
                this.query.warehouseId =  this.searchForm.warehouseId || '';//仓库
                this.query.linkNo = this.searchForm.linkNo2 || '';//领用单号
                // this.query.requisitionNo = this.query.requisitionNo2 || '';
                this.query.outboundNo = this.query.outboundNo2 || '';//出库单号
                if(this.valuetime){//出库时间
                    this.query.beginTime = this.dayjs(this.valuetime[0]).format('YYYY-MM-DD HH:mm:ss');//开始
                    this.query.endTime = this.dayjs(this.valuetime[1]).format('YYYY-MM-DD 23:59:59'); //结束
                }

                this.loading = true;
                console.log(this.query)
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    data.records.forEach(ele=>{
                        if(ele.outboundUserPhone){
                            ele.outboundNamePhone = ele.outboundUserName +'('+ ele.outboundUserPhone +')';
                        }else{
                            ele.outboundNamePhone = ele.outboundUserName;
                        }
                        if(ele.confirmUserPhone){
                            ele.confirmUserPhone = ele.confirmUserName +'('+ ele.confirmUserPhone +')';
                        }else{
                             ele.confirmUserPhone = ele.confirmUserName;
                        }

                    })
                    this.data = data.records;
                    this.loading = false;
                    // this.selectionClear();
                });
                // 获取总金额
                getSummary(Object.assign({current: page.currentPage, size: page.pageSize}, this.query)).then(res=>{
                    this.money = res.data;
                })
            }
        }
    };
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
  .money{
  text-align: right;
}
::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
